"use client";
import WebLayout from "@/components/layout/web/WebLayout";
import CPageHeader from "@/components/main/CPageHeader";
import Newsletter from "@/components/web/main/newsletter/Newsletter";
import firebase_app from "@/lib/firebase/configs";
import { Card, Grid, createStyles } from "@mantine/core";
import {
  collection,
  getDocs,
  getFirestore,
  limit,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import Image from "next/image";
import Link from "next/link";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";

const useStyles = createStyles((theme) => ({
  avatar: {
    height: "50px",
    width: "50px",
    borderRadius: "50%",
  },
  comName: {
    fontSize: "18px",
    lineHeight: "28px",
    color: "#777777",
  },
  para: {
    color: "#A4A4A4",
    fontSize: "14px",
    lineHeight: "24px",
  },
}));

const ExpertsLayout = ({ children, expertsPageData, dictionary }) => {
  const { classes } = useStyles();
  const items = [
    { title: dictionary.home, href: "/" },
    { title: expertsPageData?.landing?.title },
  ];
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathName = usePathname();
  const [searchItems, setSearchItems] = useState({});
  const [expertKeepInformed, setExpertKeepInformed] = useState([]);

  useEffect(() => {
    let temp = {};
    for (let [key, value] of searchParams.entries()) {
      if (key == "citizenships") {
        value = searchParams.getAll("citizenships");
      }
      if (key == "sectors") {
        value = searchParams.getAll("sectors");
      }
      if (key == "languages") {
        value = searchParams.getAll("languages");
      }
      if (key == "countries") {
        value = searchParams.getAll("countries");
      }
      if (key == "gender") {
        value = searchParams.getAll("gender");
      }
      if (key == "minExperience") {
        value = new Number(searchParams.get("minExperience"));
      }
      temp[key] = value;
    }

    setSearchItems(temp);
  }, [searchParams]);

  const onFilterApply = (values) => {
    router.push(
      `${pathName.split("/page")[0]}?${Object.entries(values)
        .filter((item) => item[1])
        .map((item) => {
          return Array.isArray(item[1])
            ? item[1]
              .map((item2) => `${item[0]}=${encodeURIComponent(item2)}&`)
              .join("")
            : `${item[0]}=${encodeURIComponent(item[1])}&`;
        })
        .join("")}`,
      { scroll: false }
    );
  };

  const onSearch = (text) => {
    onFilterApply({ ...searchItems, search: text });
  };

  const getKeepInformedData = async () => {
    try {
      const db = getFirestore(firebase_app);
      const q = query(
        collection(db, "Users"),
        where("role", "==", "expert"),
        where("step", "==", "completed"),
        where("active", "==", true),
        orderBy("yearsOfExperience", "desc"),
        limit(4)
      );
      const snapshot = await getDocs(q);
      const tempItems = [];
      snapshot.forEach((item) => {
        tempItems.push({ id: item.id, ...item.data() });
      });

      setExpertKeepInformed(tempItems);
    } catch (e) {}
  };

  useEffect(() => {
    getKeepInformedData();
  }, []);

  return (
    <div>
      <CPageHeader
        title={expertsPageData?.landing?.title}
        links={items}
        subTitle={expertsPageData?.landing?.description}
        onSearch={onSearch}
        dictionary={dictionary}
      />
      {children}
      <section>
        <Newsletter
          title={expertsPageData?.newsletters?.title}
          description={expertsPageData?.newsletters?.description}
          badgeTitle={expertsPageData?.newsletters?.badgeTitle}
          dictionary={dictionary}
        >
          <Grid className="w-full px-6 md:ps-6">
            {expertKeepInformed?.map((item) => (
              <Grid.Col sm={12} md={12} lg={6} key={item.id}>
                <Link
                  href={`/experts/${item.slug ? item.slug : item.id}`}
                  className="no-underline "
                >
                  <Card
                    padding={"md"}
                    style={{ borderRadius: "12px" }}
                    withBorder
                    className="card-hover"
                  >
                    <Image
                      height={50}
                      width={50}
                      src={item?.photoURL ?? '/images/user.svg'}
                      className={`${classes.avatar} rounded-full`}
                      alt={"alt"}
                    />
                    <div className="flex mt-1">
                      <div className="flex flex-col ms-[12px]">
                        <h4
                          className={`${classes.comName} p-0 hover:text-primary whitespace-nowrap m-0 transition-all duration-200 lg:max-w-[160px] lg:overflow-hidden lg:text-ellipsis`}
                        >
                          {item?.name}
                        </h4>
                        <p
                          className={`${classes.para} whitespace-nowrap m-0 lg:max-w-[160px] lg:overflow-hidden lg:text-ellipsis `}
                        >
                          {item?.position}
                        </p>
                      </div>
                    </div>
                  </Card>
                </Link>
              </Grid.Col>
            ))}
          </Grid>
        </Newsletter>
      </section>
    </div>
  );
};

export default WebLayout(ExpertsLayout);
